import { ElementRef, Output, EventEmitter } from '@angular/core';
import { UserService } from './../../../base-services/user.service';
import { ChangeDetectorRef, Input, ViewChild } from '@angular/core';
import { AbstractCustomControl } from "../../abstract-custom-control";
import { DecimalPipe } from '@angular/common';

export class BaseNumberInput extends AbstractCustomControl<number> {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected decimalPipe: DecimalPipe
    ){
        super(changeDetectorRef);
    }

    protected numberKeyCodes: number[] = [
        48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
        96, 97, 98, 99, 100, 101, 102, 103, 104, 105
    ]

    protected specialKeyCodes: number[] = [
        //backspace
        8,

        //arrows
        37, 39,

        //tab
        9,

        //escape
        27,

        //delete
        46,

        //home
        36,

        //end
        35//,

        //ctrl-a

        //minus
        //109
    ]

    protected ds: string;
    protected ts: string;
    protected nofd: number;
    //protected oldValue: number;

    displayValue: string;

    @Input() FormatString: string;
    @Output() OnChange = new EventEmitter<number>();
    @Output() OnBlur = new EventEmitter();

    ngOnInit(){
        this.ds = this.userService.GetDecimalSeparator();
        this.ts = this.userService.GetThousandSeparator();
        if(!this.FormatString)
            this.FormatString = this.userService.GetNumberFormat();
        this.nofd = parseInt(this.FormatString.substring(2, 3));
    }

    @ViewChild('input', { static: true }) inputControl: ElementRef;

    protected isNumber(keyCode: number){
        return this.numberKeyCodes.indexOf(keyCode) > -1;
    }

    protected isDs(key: string){
        return key == this.ds;
    }

    protected isAllowed(keyCode: number){
        return (this.numberKeyCodes.indexOf(keyCode) > -1
                || this.specialKeyCodes.indexOf(keyCode) > -1);
    }

    protected hasDs(selection: string){
        return this.displayValue.indexOf(this.ds) > -1 && (selection.indexOf(this.ds) == -1 || selection == '');
    }

    protected prevent(event){
        event.preventDefault();
        event.stopPropagation();
        return;
    }

    protected isBackspace(keyCode){
        return this.specialKeyCodes.indexOf(keyCode) > -1 && keyCode == 8;
    }

    onInput(event){
    }

    onBlur(){
    }

    onInputFocus(input){
    }

    onKeyDown(event){
        
    }

    setDisabledState(value: boolean){
        super.setDisabledState(value);
        this.inputControl.nativeElement.disabled = value;
        this.changeDetectorRef.markForCheck();
    }

    focus(){
        let __this = this;
        setTimeout(function(){
            __this.inputControl.nativeElement.focus()
        }, 100);
    }
}
